import { generateUtilityClasses } from '@kc-console/common-ui';

import type { FilterDefBase, FilterState } from '../DataTable/types';

export const actionBarClasses = generateUtilityClasses('ActionBar', [
  'root',
  'toolbar',
  'toolbarButtons',
  'toolbarButtonsFilterButton',
  'toolbarButtonsFilterButtonLabel',
  'toolbarButtonsActions',
  'toolbarButtonsSettingButton',
  'toolbarButtonsSettingButtonLabel',
  'toolbarPagination',
  'toolbarDivider',
  'filterContent',
  'settingContent',
]);

export type PropertyFilterType = 'inline' | 'separated';

export const getIsFilterDisabled = (filterDef: FilterDefBase, filters: FilterState[]) => {
  return typeof filterDef.disabled === 'function'
    ? filterDef.disabled(filters)
    : (filterDef.disabled ?? false);
};
